import { isNot } from 'typescript-styled-is'
import styled from '../../../theme'

const PageWidget = styled.div<IPageWidgetProps>`
  background-color: white;
  border-radius: ${({ mobile }) => (mobile ? 0 : 8)}px;
  border: 1px solid #d4d4d4;
  width: 100%;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  position: relative;
  ${isNot('desktop')`
  		margin-bottom: ${({ mobile }) => (mobile ? 0 : 30)}px;
  `}
  ${({ height }) =>
    height != null &&
    height !== '' &&
    `height: ${typeof height === 'number' ? `${height}px` : height};`}
`

export default PageWidget

export interface IPageWidgetProps {
  desktop?: boolean
  mobile?: boolean
  height?: string | number
}
